import React from "react";
import { TextInputField, DropDownField } from "../../../helpers";


const DispatchAddress = (props) => {
    const { dispatchDetails, handleDispatchAddressChange, useBillAddrsAsDispatch, statesList } = props

    return(
        <div className="p-card">
            <div className="grid">
                {/*<div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                    <DropDownField name="" labelText="Short Name" value="" disabled={useBillAddrsAsDispatch} />
                </div>*/}
                <div className="flex flex-column col-12 lg:col-7 lg:mb-0">
                    {/* <TextInputField name="billAddress" labelText="Address" value={dispatchDetails?.billAddress} onChange={handleDispatchAddressChange} disabled={useBillAddrsAsDispatch} /> */}
                    <TextInputField name="shipAddr" labelText="Address" value={dispatchDetails?.shipAddr} onChange={handleDispatchAddressChange} disabled={useBillAddrsAsDispatch} required />
                </div>
                <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                    <TextInputField name="pinCode" labelText="Pin Code" value={dispatchDetails?.pinCode} keyfilter={"pint"} autoComplete={"off"} maxLength={6} onChange={handleDispatchAddressChange} disabled={useBillAddrsAsDispatch} required />
                </div>
                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                    <TextInputField name="city" labelText="City" value={dispatchDetails?.city} onChange={handleDispatchAddressChange} disabled={useBillAddrsAsDispatch} required />
                </div>
                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                    <DropDownField name="stateId" options={statesList} labelText="State" optionLabel={"stateName"} optionValue={"stateId"} value={dispatchDetails.stateId} onChange={handleDispatchAddressChange} disabled={true} required />
                </div>
                <div className="flex flex-column col-12 lg:col-5 lg:mb-0">
                    <TextInputField name="companyName" labelText="Company Name" value={dispatchDetails?.companyName} onChange={handleDispatchAddressChange} disabled={useBillAddrsAsDispatch} required />
                </div>
                <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                    <TextInputField name="gstinCode" labelText="GSTIN" value={dispatchDetails?.gstinCode} onChange={handleDispatchAddressChange} disabled={useBillAddrsAsDispatch} required />
                </div>
            </div>
        </div>
    )
}

export default DispatchAddress;